import { render, staticRenderFns } from "./PasswordResetErrorCard.vue?vue&type=template&id=75fa1b5b&scoped=true"
import script from "./PasswordResetErrorCard.vue?vue&type=script&lang=js"
export * from "./PasswordResetErrorCard.vue?vue&type=script&lang=js"
import style0 from "./PasswordResetErrorCard.vue?vue&type=style&index=0&id=75fa1b5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fa1b5b",
  null
  
)

export default component.exports